import Component from 'vue-class-component';
import { Mixins , Watch } from 'vue-property-decorator';
import { IparamsSplitTabs } from '@/courses/interfaces/params-split-tabs.interface';
import { IparamsSplitOrientation } from '@/courses/interfaces/params-split-orientation.interface';
import { WidgetTeacherHomework } from '@/homework/models/widget-teacher-homework.model';
import { HOMEWORK_STATUS } from '@/homework/values/homeworks.values';
import EdSplitTabs from '@/courses/components/ed-split-tabs/ed-split-tabs.vue';
import EdSplitVertical from '@/courses/components/ed-split-vertical/ed-split-vertical.vue';
import EdSplitHorizontal from '@/courses/components/ed-split-horizontal/ed-split-horizontal.vue';
import EdMaterialViewer from '@/courses/components/ed-material-viewer/ed-material-viewer.vue';
import EdResponseTypeObject from '@/courses/components/type-object/ed-response-type-object-edupad/ed-response-type-object.vue';
import {COURSE_EVENTS} from '@/content/values/events';
import { CourseViewerSplitObjectMixin } from '@/courses/mixins/course-viewer-split-object.mixin';
import { TEACHER_PORTAL_KEYS } from '@/content/pages/teacher-portal/values/teacher-portal.values';
import { LocalStorageService } from '@/services/local-storage.service';
import { COURSE_TABS } from '@/courses/values/courses.values';
import Moment from 'moment';
import { CORE_ROUTES } from '@/core/core.router';
import { ScreenMirroringMixin } from '@/screen-mirroring/mixins/screen-mirroring.mixin';

@Component({ name: 'ed-viewer-type-object',
  components: {
    EdSplitTabs,
    EdSplitVertical,
    EdSplitHorizontal,
    EdResponseTypeObject,
    EdMaterialViewer
  }
})
export default class EdViewerTypeObject extends Mixins(CourseViewerSplitObjectMixin, ScreenMirroringMixin) {

  /* Computed */
  get responseDraft(): WidgetTeacherHomework {
    if(this.section.homeworkInfo) {
      switch(this.section.homeworkStatus) {
        case HOMEWORK_STATUS.DRAFT:
          return this.section.homeworkInfo;
        break; 
      }
    }
    return null;
  }
  
  get responseUrl(): string {
    if(this.response) {
      return this.section.homeworkInfo.homeworkAssetInfo.url;
    }
    return null;
  }

  get hasBeenResolvedByAnyStudent() {
    return this.section.hasBeenResolvedByAnyStudent ? this.section.hasBeenResolvedByAnyStudent : false;
  }

  get numberOfResponses(): number {
    return Number(JSON.parse(this.section.text).answers);
  }

  get splitTabsParams(): IparamsSplitTabs {
    return {
      contentsId: this.contentsId,
      hasSplits: true,
      oneviewSelected: this.oneviewSelected,
      tabSelected: this.tabSelected 
    }
  }

  get splitOrientationParams(): IparamsSplitOrientation {
    return {
      menuSplitFirst: this.menuSplitFirst,
      menuSplitSecond : this.menuSplitSecond,
      answer: this.answer , isTeacher: this.isTeacher,
      response: true
    }
  }

  get responseDisabled() {
    let res = { value: false, message: '' };
    const now = Moment().format('YYYY-MM-DD');
    if(this.section.submissionDates) {
      if(this.section.submissionDates.lastDate) {
        res.value = Moment(now).isAfter(this.section.submissionDates.lastDate);  
      } else if(this.section.submissionDates.dueDate) {
        res.value = Moment(now).isAfter(this.section.submissionDates.dueDate);  
      }
    }
    res.message = res.value ? this.$i18n.t('courses.typeObject.taskExpired').toString() : '';
    return res;
  }

  /* watchers */
  @Watch('tabSelected', { immediate: false, deep: true })
  reload() {
    const responseTypeObj: any = this.$refs.EdResponseTypeObject;
    if(!this.isTeacher && responseTypeObj) {
      responseTypeObj.reloadEditors();
    }
  }

  @Watch('userModeForScreenMirroring', { immediate: false, deep: true })
  reloadScreenMirroring() {
    this.setTab(this.contentsId.splitHorizontal);
  }

  /* Methods */
  public setTab(contentId: string) {
    if( this.isScreenMirroringPaperModeActive ) {
      this.settingTab({
        contentId: this.contentsId.problem, 
        el: this.$refs.EdViewerTypeObjectTabs,
        response: true
      });
      this.splitTabsParams.hasSplits = false;
      this.menu.forEach(m => {
        m.visible = ( m.contentId === this.contentsId.problem );
      });

    } else if( this.isScreenMirroringBookModeActive ) {
      this.settingTab({
        contentId: this.contentsId.response, 
        el: this.$refs.EdViewerTypeObjectTabs,
        response: true
      });
      this.splitTabsParams.hasSplits = false;
      this.menu.forEach(m => {
        m.visible = ( m.contentId === this.contentsId.response );
      });

    } else {
      this.settingTab({
        contentId: contentId, 
        el: this.$refs.EdViewerTypeObjectTabs,
        response: true
      });
    }
  }

  public goToResponses() {
    let courseId = this.courseId || this.section.courseId;
    LocalStorageService.setItem(
      COURSE_TABS.ED_PORTAL_TAB,
      COURSE_TABS.TASKS_TAB
    );
    LocalStorageService.setItem(
      TEACHER_PORTAL_KEYS.TASKS_HOMEWORKS_TAB, 
      TEACHER_PORTAL_KEYS.TASKS_HOMEWORKS_SECTIONS_TAB
    );
    LocalStorageService.setItem(
      TEACHER_PORTAL_KEYS.TASKS_COURSE_ID, 
      courseId
    );
    LocalStorageService.setItem(
      TEACHER_PORTAL_KEYS.TASKS_HOMEWORK_ID, 
      this.section.id
    );
    this.$router.push({ name: CORE_ROUTES.PORTAL.NAME });
  }
  
  /* Hooks */
  setObjectFullScreen(isFullScreen: boolean) {
    this.isFullScreen = isFullScreen;
  }

  created() {
    this.setFiles();
    this.setMenu(true, true);
    this.setMenuSplit(true);

    this.$edEventBus.$on(COURSE_EVENTS.SET_OBJECT_FULL_SCREEN, this.setObjectFullScreen);
  }

  mounted() {
    this.setTab(this.contentsId.splitHorizontal);
  }

  beforeDestroy() {
    this.$edEventBus.$off(COURSE_EVENTS.SET_OBJECT_FULL_SCREEN, this.setObjectFullScreen);
  }
  
}